<template lang="pug">
  el-breadcrumb.breadcrumb-nav(
    separator-class="el-icon-arrow-right")
    //- el-breadcrumb-item(:to="{ path: '/' }") 昆明手机抄表平台
    el-breadcrumb-item(
      v-for="item in breadcrumbList"
      :key="item.path"
      :to="{ path: item.url }") {{item.label}}
</template>
<script>
import { fullPath } from '../nav'
export default {
  name: 'Breadcrumb',
  props: {
    routesPure: Array
  },
  computed: {
    breadcrumbList () {
      return fullPath(this.$route, this.routesPure)
    }
  }
}
</script>
<style scoped lang="sass">
.breadcrumb-nav
  font-size: 14px
  margin-left: 20px
</style>



// WEBPACK FOOTER //
// Breakcrumb.vue?19ad5e2d